import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import api from 'api';
import type { ActivityEventTypeOption } from 'types';

const HOUR_MS = 60 * 60 * 1000;

export const activityEventTypeKeys = {
    all: ['activityEventTypes'] as const,
};

/** Catalog of activity event types. Changes rarely — cached for an hour. */
export const useActivityEventTypes = (options?: { enabled?: boolean }) => {
    const query = useQuery<ActivityEventTypeOption[]>({
        queryKey: activityEventTypeKeys.all,
        queryFn: async () => {
            const response = await api.activityEvents.getActivityEventTypes();
            return response.data?.event_types ?? [];
        },
        enabled: options?.enabled ?? true,
        staleTime: HOUR_MS,
        gcTime: HOUR_MS,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const typeOptions = query.data ?? [];
    const defaultTypes = useMemo(
        () => typeOptions.filter((option) => option.default_tracked),
        [typeOptions]
    );

    return { ...query, typeOptions, defaultTypes };
};
